/// <amd-module name="Feed/Legacy/Protocols/Components/SimpleOverviewAttributesPanel" />
import * as React from "react";

import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { PackageDependencies } from "Feed/Legacy/Protocols/Components/PackageDependencies";
import { PackagePeople } from "Feed/Legacy/Protocols/Components/PackagePeople";
import { PackageProvenance } from "Feed/Legacy/Protocols/Components/PackageProvenance";
import { PackageTags } from "Feed/Legacy/Protocols/Components/PackageTags";

export class SimpleOverviewAttributesPanel extends React.PureComponent<IPackageDetailsProps> {
    public render(): JSX.Element {
        return (
            <div className="package-details-panel">
                <PackageProvenance
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageId={this.props.packageSummary.id}
                    versionId={this.props.packageVersion.id}
                    publishDate={new Date(this.props.packageVersion.publishDate)}
                    isProvenanceEnabled={this.props.isProvenanceEnabled}
                    isProvenanceSupported={false}
                />
                {this.props.packageVersion.author && (
                    <PackagePeople authors={this.props.packageVersion.author.split(",")} />
                )}
                <PackageDependencies
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                    dependencyHelperCallback={null}
                    isSmartDependenciesEnabled={this.props.isSmartDependenciesEnabled}
                />
                <PackageTags tags={this.props.packageVersion.tags} />
            </div>
        );
    }
}
